const tooltipDirective = {
  beforeMount(el, binding) {
    const tooltipText = document.createElement('div');
    tooltipText.style.position = 'absolute';
    tooltipText.style.backgroundColor = 'rgba(255, 255, 255, 1)';
    tooltipText.style.color = 'rgba(100, 114, 140, 1)';
    tooltipText.style.padding = '10px';
    tooltipText.style.borderColor = '#F3F3F3FF';
    tooltipText.style.borderStyle = 'solid';
    tooltipText.style.borderWidth = '1px';

    tooltipText.style.borderRadius = '5px';
    tooltipText.style.fontSize = '12px';
    tooltipText.style.whiteSpace = 'nowrap';
    tooltipText.style.zIndex = '1000';
    tooltipText.style.visibility = 'hidden'; // Hide by default
    tooltipText.textContent = binding.value;

    el._tooltipText = tooltipText;
    document.body.appendChild(tooltipText);

    // Position and show tooltip on hover
    // eslint-disable-next-line
    el.addEventListener('mouseenter', (event) => {
      const {top, left, width} = el.getBoundingClientRect();
      const tooltipHeight = tooltipText.offsetHeight;
      tooltipText.style.top = `${top + window.scrollY - tooltipHeight - 10}px`;
      tooltipText.style.left = `${
        left + window.scrollX + width / 2 - tooltipText.offsetWidth / 2
      }px`;
      tooltipText.style.visibility = 'visible';
    });

    // Hide tooltip when mouse leaves
    el.addEventListener('mouseleave', () => {
      tooltipText.style.visibility = 'hidden';
    });
  },

  unmounted(el) {
    if (el._tooltipText) {
      document.body.removeChild(el._tooltipText);
    }
  },
};

export default tooltipDirective;
